import { Moment } from 'moment';
import {
  Column,
  RadioGroupOption,
  SelectOptionElement,
} from '@odin-labs/components';
import {
  GetScheduleDetailsQuery,
  ScheduleWorkerType,
} from 'apollo/generated/client-operations';

export type JobsiteSchedulesContextType = {
  canChangeSchedule: boolean;
  completeSchedule: () => void;
  date: Moment;
  editSchedule: () => void;
  gotoNextDay: () => void;
  gotoPrevDay: () => void;
  handleDateChange: (newDate: Moment) => void;
  isScheduleEditable: boolean;
  isScheduleLive: boolean;
  jobsiteId: string;
  loading: boolean;
  selectedSchedule?: Schedule | null;
};

export type JobsiteScheduledWorkerFormFields = {
  activity: SelectOptionElement;
  jobsiteContractorId: SelectOptionElement;
  jobsiteWorkerId?: SelectOptionElement;
  notes: string;
  trade: SelectOptionElement;
  quantity?: number;
  type: RadioGroupOption<ScheduleWorkerType>;
};

export type Schedule = GetScheduleDetailsQuery['getSchedule'];
export type ScheduleShift = Schedule['shifts'][number];
export type ScheduleWorker = ScheduleShift['workers']['edges'][number]['node'];
export type ScheduleAttendanceEntry =
  ScheduleShift['attendance']['edges'][number]['node'];

export type JobsiteScheduleShiftFormFields = {
  startTime: string;
  duration: number;
};

export type AttendanceColumn = Column<ScheduleAttendanceEntry>;
export enum AttendanceColumnName {
  Contractor = 'contractor',
  Status = 'status',
  Activity = 'activity',
  Trade = 'trade',
  Worker = 'worker',
  Start = 'start',
  End = 'end',
  TotalHours = 'totalHours',
  Actions = 'actions',
}

export type EditableShiftColumn = Column<ScheduleWorker>;
export enum EditableShiftColumnName {
  Contractor = 'contractor',
  Trade = 'trade',
  Activity = 'activity',
  Count = 'workerCount',
  Actions = 'actions',
}
export type ScheduleWorkerModalValue = {
  scheduleWorker: ScheduleWorker;
  modalAction: 'edit' | 'delete' | 'viewNotes';
};
